const study = [
    {
        path: '/study/:id',
        name: 'study',
        component: () => import('@/view/study/Index'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/test/:id',
        name: 'test',
        component: () => import('@/view/study/Test'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/test/result/success',
        name: 'testSuccess',
        component: () => import('@/view/study/Success'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/print/:id',
        name: 'print',
        component: () => import('@/view/study/Print'),
        meta: {
            requireAuth: true
        }
    }
]
export default study
